import SlotDefinition from "slotworks/model/slot-definition";
import slotDefinition from "slotworks/model/slot-definition";
import Point from "slotworks/utils/geom/point";

export function convertQFSymbolPositions(symbolIndexes: string) {
    const symbols = symbolIndexes.split(",").map((value) => parseInt(value));

    const numRows = SlotDefinition.matrixGrid.length;

    const positions = [];

    for (const symbol of symbols) {
        const x = symbol % numRows;
        const y = Math.floor(symbol / numRows);

        positions.push(new Point(x, y));
    }

    return positions;
}

export function convertQFGridToSlotworksGrid(rawSymbols: string) {
    const symbols = rawSymbols.split(",").map((value) => parseInt(value));

    const symbolIds = symbols.map((symbolIndex) => {
        // -1 usually indicates a symbol in the grid which has not yet been unlocked
        // (for variable sized grid games), so make it use the last symbol in game-config, which should be blank
        if (symbolIndex === -1) {
            symbolIndex = slotDefinition.symbolDefinitions.length - 1;
        }
        return slotDefinition.symbolDefinitions[symbolIndex].id;
    });

    const grid: string[][] = [];

    const numReels = SlotDefinition.matrixGrid.length;
    for (let col = 0; col < numReels; col++) {
        const reel: string[] = [];
        grid.push(reel);

        const reelSize = SlotDefinition.matrixGrid[col];
        for (let row = 0; row < reelSize; row++) {
            reel.push(symbolIds[col + row * numReels]);
        }
    }

    return grid;
}
